/**
 * In Audit API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const FormFieldType = {
    Text: 'text',
    Number: 'number',
    Date: 'date',
    Time: 'time',
    Select: 'select',
    Checkbox: 'checkbox',
    PhotoPicker: 'photoPicker',
    Divider: 'divider',
    Signature: 'signature'
} as const;
export type FormFieldType = typeof FormFieldType[keyof typeof FormFieldType];

